import React from 'react';
import mrPrimoLogo from '../images/MrPrimo-LOGO-sm.png';
import './Footer.css';

/**
 * Footer component for the Off Planner application
 * Displays the MrPrimo logo with a link to the website
 */
const Footer = () => {
  return (
    <footer className="app-footer">
      <a href="http://mrprimo.org" target="_blank" rel="noopener noreferrer">
        <img 
          src={mrPrimoLogo} 
          alt="MrPrimo Logo" 
          className="footer-logo"
        />
      </a>
    </footer>
  );
};

export default Footer;
